import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";

/** Applique l'identité visuelle d'une société (Builder) sur :root. */
export function applySocieteBranding(branding) {
  if (!branding) return;
  const root = document.documentElement;
  if (branding.primary) root.style.setProperty("--brand-primary", branding.primary);
  if (branding.secondary) root.style.setProperty("--brand-secondary", branding.secondary);
  if (branding.accent) root.style.setProperty("--brand-accent", branding.accent);
}

/**
 * Config effective (branding + fonctions) résolue côté serveur pour l'utilisateur courant.
 * Priorité : session → société explicite → en-tête X-Societe-Id → société du partenaire / de l'inscription → défaut.
 */
export function useAppConfig({ sessionId, societeId, apply = true } = {}) {
  const { axiosAuth, user } = useAuth();
  const [config, setConfig] = useState(null);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    const params = {};
    if (sessionId) params.session_id = sessionId;
    if (societeId) params.societe_id = societeId;
    axiosAuth().get("/me/app-config", { params })
      .then((r) => {
        if (cancelled) return;
        setConfig(r.data);
        if (apply) applySocieteBranding(r.data?.branding);
      })
      .catch(() => {});
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [sessionId, societeId, user?.user_id]);

  const features = config?.features || {};
  const isOn = (key) => features[key] !== false;
  return { config, branding: config?.branding || {}, features, isOn, loaded: !!config };
}

/** Filtre « SCORM uniquement » appliqué à une liste de séquences/modules. */
export function filterScormOnly(sequences, features) {
  if (!features?.scorm_only) return sequences;
  return (sequences || []).filter((s) => s.kind === "scorm" || s.type === "scorm");
}
